export default __webpack_public_path__ + "static/media/13.72f8daa9.png";